export default "__VITE_ASSET__DvO9A6aK__"